import { getAutomotiveRoleAsString } from 'lib/utils/automotiveRolePermissionChecks';
import React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { capitalizeWords } from 'lib/utils/functions';
import { AccessRole } from 'lib/const';
import { StatusBadge, Tooltip } from 'react-covideo-common';

const BadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 10px;
`;

const AutomotiveRoleBadge = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  gap: 10px;
  background: ${({ theme }) => theme.colors.secondary['non_alpha']};
  border-radius: 6px;
`;

const AutomotiveRoleBadgeText = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: capitalize;
  font-feature-settings:
    'tnum' on,
    'lnum' on;
  color: ${theme.palette.primaryDarkBlue};
  flex: none;
  order: 0;
  flex-grow: 0;
`;

type Props = {
  isAutomotive: boolean;
  automotiveRole: number;
  access?: string;
  isMLUser: boolean;
};
export const UserAccessBadge = ({
  isAutomotive,
  automotiveRole,
  access,
  isMLUser,
}: Props) => {
  const getBadge = ({
    text,
    hoverText,
  }: {
    text: string;
    hoverText: string;
  }) => {
    return (
      <Tooltip popup={<>{hoverText}</>}>
        <StatusBadge text={text} variant='dark' size='small' />
      </Tooltip>
    );
  };
  return (
    <BadgeWrapper>
      {isAutomotive && getAutomotiveRoleAsString(automotiveRole) !== '' && (
        <AutomotiveRoleBadge>
          <AutomotiveRoleBadgeText>
            {capitalizeWords(getAutomotiveRoleAsString(automotiveRole))}
          </AutomotiveRoleBadgeText>
        </AutomotiveRoleBadge>
      )}
      {access === AccessRole.ADMIN &&
        getBadge({ text: 'A', hoverText: 'Admin' })}
      {access === AccessRole.SUPERVISOR &&
        getBadge({
          text: 'S',
          hoverText: 'Supervisor',
        })}
      {!!isMLUser &&
        getBadge({
          text: 'ML',
          hoverText: 'Multi-Location',
        })}
    </BadgeWrapper>
  );
};
